var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUpload = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "7 7 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M12.312 11c-.297 0-.393-.264-.214-.5l2.586-3.326c.179-.235.468-.23.647.004l2.587 3.322c.179.235.082.5-.215.5H16v4.5c0 .275-.216.5-.492.5h-1a.507.507 0 0 1-.508-.5V11zM18 15.5v-1c0-.276.231-.5.508-.5h3.5c.552 0 .992.447.992 1v7c0 .553-.44 1-.992 1h-14A1.006 1.006 0 0 1 7 22v-7c0-.553.455-1 1.008-1h3.5c.276 0 .492.224.492.5v1c0 .276-.216.5-.492.5H9v3h12v-3h-2.492a.506.506 0 0 1-.508-.5"
})));
export default SvgUpload;